// Detecção automática do ambiente
const isDevelopment = () => {
  
  // Verifica se está rodando em localhost
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '0.0.0.0') {
      return true;
    }
  
  return false;
};

const url = () => {
  if (isDevelopment()) {
    return "http://localhost:4001";
  }
  return "https://app-farol-backend.somalabs.com.br";
};
  
const url_fotos = () => {
  if (isDevelopment()) {
    return "http://localhost:8080";
  }
  return "https://estudio-online-api-zqshxhdkqa-uc.a.run.app";
};

export default { url, url_fotos };
